export enum PrizesCouponType {
  POINTS = 1,
  PRODUCTS = 2,
  STICKER = 3,
  SCRATCH = 4
}